var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoPictSeason(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 164,
    viewBox: "0 0 280 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_169734_18521)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 164,
    rx: 4,
    fill: "#E8EDF1"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_169734_18521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152 70H128C126.666 70 125.333 71.3333 125.333 72.6667V91.3333C125.333 92.8 126.533 94 128 94H152C153.333 94 154.666 92.6667 154.666 91.3333V72.6667C154.666 71.3333 153.333 70 152 70ZM130.666 88.6667L135.333 82.6667L138.666 86.68L143.333 80.6667L149.333 88.6667H130.666Z",
    fill: "#BAC7D5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_169734_18521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 164,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_169734_18521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(124 66)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPictSeason);
export default __webpack_public_path__ + "static/media/noPictSeason.1efba4079503d6062f263ee49f2001b2.svg";
export { ForwardRef as ReactComponent };